import { apiClient, apiErrorHandler, ADMIN_URL } from 'src/app/common/network';
import { Dispatch } from 'react';
import { getError } from '../comm';
import { AWARD_UPLOAD_TYPE, CREDIT_UPLOAD_TYPE } from '../types/bulk-upload-types';

const bulkUploadEndpoint = '/pruwallet/admin';

const handleUploadTYpe = (type: string) => {
  switch (type) {
    case AWARD_UPLOAD_TYPE.AWARD_PRELOAD:
      return 'PROMO_INVENTORY_PRELOAD';
    case AWARD_UPLOAD_TYPE.AWARD_ADJUMENT:
      return 'PROMO_INVENTORY_ADJUST';
    case CREDIT_UPLOAD_TYPE:
      return 'CREDIT_ADJUSTMENT';
  }
};

export const downloadBulkUploadCsv = async (uploadType: string, dispatch?: Dispatch<any>): Promise<string> => {
  const path = `${ADMIN_URL}${bulkUploadEndpoint}/bulk-operations/sample-csv/${handleUploadTYpe(uploadType)}`;
  return apiClient
    .get<string>(path)
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(getError(err), dispatch);
    });
};

export const bulkUploadAward = async (
  file: File | null,
  filename: string,
  uploadType: string,
  sendNotification: boolean,
  blobId: string,
) => {
  const type = uploadType === AWARD_UPLOAD_TYPE.AWARD_PRELOAD ? 'preload' : 'adjust';
  const path = `${ADMIN_URL}${bulkUploadEndpoint}/awards/promo-codes/bulk-upload-combine`;
  return apiClient
    .post<string>(
      `${path}?filename=${encodeURIComponent(
        filename,
      )}&type=${type}&sendNotification=${sendNotification}&blobId=${blobId}`,
      file,
      {
        headers: { Accept: 'application/json', 'Content-Type': 'text/csv' },
      },
    )
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(getError(err));
    });
};

export const bulkUploadCredit = async (
  file: File | null,
  filename: string,
  requireNotification: boolean,
  blobId: string,
) => {
  const path = `${ADMIN_URL}${bulkUploadEndpoint}/credit/bulk-adjustment`;
  return apiClient
    .post<string>(
      `${path}?filename=${encodeURIComponent(filename)}&requireNotification=${requireNotification}&blobId=${blobId}`,
      file,
      {
        headers: { Accept: 'application/json', 'Content-Type': 'text/csv' },
      },
    )
    .then((response) => response.data)
    .catch((err) => {
      throw apiErrorHandler(getError(err));
    });
};

export const approveBulkOperation = async (
  operationId: string,
  approvedBy: string,
  sourceService: string,
  dispatch?: Dispatch<any>,
) => {
  const path = `${ADMIN_URL}${bulkUploadEndpoint}/bulk-operations/${operationId}/approve`;
  return apiClient
    .post(path, { approvedBy, sourceService })
    .then((response) => response.data.data)
    .catch((err) => {
      throw apiErrorHandler(getError(err), dispatch);
    });
};
